import { z } from "zod";

export const reviewSchema = z.object({
    rating: z
        .number({ required_error: "별점을 선택해주세요" })
        .min(1, "별점을 선택해주세요")
        .max(5, "별점은 5점까지 가능합니다"),
    content: z
        .string({ required_error: "리뷰 내용을 입력해주세요" })
        .min(10, "최소 10자 이상 작성해주세요")
        .max(500, "최대 500자까지 작성 가능합니다"),
});
